export const Contact: React.FC = () => {
    return(<h1>Contact us page!</h1>)
}
